export default "__VITE_ASSET__Ch$5D$3N__"